import React, { lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Gift, CheckCircle2, Sparkles } from 'lucide-react';
interface PremiumBonus {
  image: string;
  alt: string;
  badge: string;
  title: string;
  description: string;
  features: string[];
  value: string;
}
export function MarcaPrivadaBonuses() {
  const bonuses: PremiumBonus[] = [{
    image: 'https://cdn.magicpatterns.com/uploads/ciL2jTgTS8zR6kzwGZyQE7/bono_1_IMP.png',
    alt: 'Bono Premium #1: Lista de Proveedores Verificables',
    badge: 'BONO PREMIUM #1',
    title: 'LISTA DE PROVEEDORES VERIFICABLES™',
    description: 'Aprende cómo encontrar proveedores reales, negociar mejores precios y evitar errores costosos al importar desde China.',
    features: ['Proveedores confiables y verificados', 'Método profesional de negociación', 'Mejores precios al importar', 'Evita errores costosos comunes'],
    value: '$17'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/re9GwYmQE9R23XNmvBcFM5/Bono_2_IMP.png',
    alt: 'Bono Premium #2: Productos Virales Recomendados',
    badge: 'BONO PREMIUM #2',
    title: 'PRODUCTOS VIRALES RECOMENDADOS™',
    description: 'Aprende cómo detectar tendencias, validar productos y encontrar oportunidades antes que la competencia.',
    features: ['Detecta tendencias antes que nadie', 'Analiza el mercado paso a paso', 'Encuentra productos ganadores', 'Valida antes de invertir'],
    value: '$19'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/8KZ8fTUY1smKa8ArUCyCJb/Bono_3_IMP.png',
    alt: 'Bono Premium #3: Cómo Encontrar Productos con IA',
    badge: 'BONO PREMIUM #3',
    title: 'CÓMO ENCONTRAR PRODUCTOS CON IA™',
    description: 'Aprende cómo usar Inteligencia Artificial y prompts premium para encontrar productos ganadores más rápido.',
    features: ['Ideas ilimitadas con IA', 'Investigación inteligente y precisa', 'Validación de ideas en minutos', 'Prompts exclusivos listos para usar'],
    value: '$27'
  }];
  return <section className="bg-brand-green py-24 px-6 relative overflow-hidden" data-id="element-281">
      {/* Decorative background */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-282">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-283"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-beige rounded-full blur-3xl" data-id="element-284"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-285">
        {/* Header */}
        <FadeIn data-id="element-286">
          <div className="text-center mb-16" data-id="element-287">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6" data-id="element-288">
              <Gift className="w-8 h-8 text-brand-gold" data-id="element-289" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-290">
              🎁 ACCESO A BONOS PREMIUM INCLUIDOS
            </h2>
            <p className="text-lg md:text-xl text-white/60 max-w-3xl mx-auto leading-relaxed" data-id="element-291">
              Además del sistema principal, recibirás herramientas prácticas
              diseñadas para ayudarte a importar desde China, encontrar
              productos ganadores y construir una marca profesional.
            </p>
          </div>
        </FadeIn>

        {/* Bonus Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14" data-id="element-292">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-293">
              <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden h-full flex flex-col hover:border-brand-gold/30 transition-colors" data-id="element-294">
                {/* Image */}
                <div className="p-5 pb-0" data-id="element-295">
                  <img src={bonus.image} alt={bonus.alt} loading="lazy" className="w-full h-auto rounded-xl object-contain" data-id="element-296" />
                </div>

                {/* Content */}
                <div className="p-8 pt-5 flex flex-col flex-1" data-id="element-297">
                  {/* Badge */}
                  <span className="inline-block w-fit text-xs font-bold tracking-wider text-brand-gold bg-brand-gold/10 border border-brand-gold/30 px-3 py-1 rounded-full mb-3" data-id="element-298">
                    {bonus.badge}
                  </span>

                  {/* Title */}
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3" data-id="element-299">
                    {bonus.title}
                  </h3>

                  {/* Description */}
                  <p className="text-white/50 text-sm md:text-base leading-relaxed mb-6" data-id="element-300">
                    {bonus.description}
                  </p>

                  {/* Features */}
                  <div className="space-y-3 mb-6" data-id="element-301">
                    {bonus.features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-302">
                        <CheckCircle2 className="w-4 h-4 text-brand-gold flex-shrink-0 mt-0.5" data-id="element-303" />
                        <span className="text-sm text-white/80 font-medium" data-id="element-304">
                          {feature}
                        </span>
                      </div>)}
                  </div>

                  {/* Value */}
                  <div className="mt-auto pt-5 border-t border-white/10 flex items-center justify-between" data-id="element-305">
                    <span className="text-xs uppercase tracking-wider text-white/50 font-semibold" data-id="element-306">
                      Valor oficial
                    </span>
                    <span className="text-2xl font-bold text-brand-gold" data-id="element-307">
                      {bonus.value} USD
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>

        {/* Total recap */}
        <FadeIn delay={0.5} data-id="element-308">
          <div className="bg-white/5 border border-brand-gold/30 rounded-2xl px-6 sm:px-10 py-10 max-w-3xl mx-auto" data-id="element-309">
            <div className="text-center mb-7" data-id="element-310">
              <Sparkles className="w-8 h-8 text-brand-gold mx-auto mb-3" data-id="element-311" />
              <p className="text-xs sm:text-sm uppercase tracking-[0.2em] text-brand-gold font-bold mb-2" data-id="element-312">
                Resumen
              </p>
              <h3 className="text-2xl md:text-3xl font-bold text-white" data-id="element-313">
                TODO LO QUE RECIBES HOY
              </h3>
            </div>

            <div className="space-y-3 mb-7" data-id="element-314">
              <div className="flex items-center justify-between gap-3 bg-white/5 border border-white/10 rounded-xl px-4 sm:px-5 py-3" data-id="element-315">
                <div className="flex items-center gap-3 min-w-0" data-id="element-316">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-317" />
                  <span className="text-sm md:text-base text-white font-semibold truncate" data-id="element-318">
                    Sistema de Marca Privada™
                  </span>
                </div>
                <span className="text-sm md:text-base font-bold text-brand-gold whitespace-nowrap" data-id="element-319">
                  $67 USD
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 bg-white/5 border border-white/10 rounded-xl px-4 sm:px-5 py-3" data-id="element-320">
                <div className="flex items-center gap-3 min-w-0" data-id="element-321">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-322" />
                  <span className="text-sm md:text-base text-white font-semibold truncate" data-id="element-323">
                    Bono Premium #1
                  </span>
                </div>
                <span className="text-sm md:text-base font-bold text-brand-gold whitespace-nowrap" data-id="element-324">
                  $17 USD
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 bg-white/5 border border-white/10 rounded-xl px-4 sm:px-5 py-3" data-id="element-325">
                <div className="flex items-center gap-3 min-w-0" data-id="element-326">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-327" />
                  <span className="text-sm md:text-base text-white font-semibold truncate" data-id="element-328">
                    Bono Premium #2
                  </span>
                </div>
                <span className="text-sm md:text-base font-bold text-brand-gold whitespace-nowrap" data-id="element-329">
                  $19 USD
                </span>
              </div>
              <div className="flex items-center justify-between gap-3 bg-white/5 border border-white/10 rounded-xl px-4 sm:px-5 py-3" data-id="element-330">
                <div className="flex items-center gap-3 min-w-0" data-id="element-331">
                  <CheckCircle2 className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-332" />
                  <span className="text-sm md:text-base text-white font-semibold truncate" data-id="element-333">
                    Bono Premium #3
                  </span>
                </div>
                <span className="text-sm md:text-base font-bold text-brand-gold whitespace-nowrap" data-id="element-334">
                  $27 USD
                </span>
              </div>
            </div>

            {/* Total */}
            <div className="text-center border-t border-white/10 pt-7" data-id="element-335">
              <p className="text-xs sm:text-sm uppercase tracking-widest text-white/60 mb-1 font-semibold" data-id="element-336">
                Valor total real
              </p>
              <p className="text-4xl md:text-5xl font-bold text-brand-gold mb-5 tracking-tight" data-id="element-337">
                $130 USD+
              </p>

              <button type="button" onClick={() => window.open('https://43skvt-1y.myshopify.com/products/sistema-de-marca-privada%E2%84%A2', '_blank', 'noopener,noreferrer')} className="group bg-brand-gold/10 hover:bg-brand-gold/20 border border-brand-gold/40 hover:border-brand-gold rounded-2xl px-6 py-5 mb-3 inline-block cursor-pointer transition-all duration-300 hover:shadow-2xl hover:shadow-brand-gold/30 hover:-translate-y-0.5 active:translate-y-0" data-id="element-338">
                <p className="text-xs sm:text-sm uppercase tracking-widest text-white/70 group-hover:text-brand-gold font-semibold mb-1 transition-colors" data-id="element-339">
                  🔥 Hoy solo · Toca para comprar
                </p>
                <p className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-340">
                  $36.99 USD
                </p>
              </button>
              <p className="text-xs sm:text-sm text-white/55 italic mt-3" data-id="element-341">
                Oferta de lanzamiento — puede cambiar en cualquier momento.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}